const baseUrl = window.location.origin;

export const URLs = {
  links: baseUrl + "/api/filteredLinks",
};
